import { format } from "date-fns";
import { map, get, indexOf } from "lodash";
import * as debug from "../Atollon/debug";
import Translate from "../Atollon/Translation";

/**
 * Parse query string from redux-router into simple object
 *
 * @param {String} location
 * @return {Object} query
 */
export const queryParser = location => {
  let query = {};
  let qString = get(location, "search");
  qString = (qString[0] === "?" ? qString.substr(1) : qString).split("&");
  map(qString, value => {
    value = value.split("=");
    query = {
      ...query,
      [value[0]]: value[1]
    };
  });

  return query;
};

/**
 * Redirect to url
 *
 * @param {Object} url
 */
export const redirectTo = url => {

  if (debug.debug_isEnabled()) {
      console.log('redirectTo', url);
  }

  if (url[0] !== "{")
    window.location.replace(
      url.replace(/redirectUri=[^&]*/g, "redirectUri=" + window.location.href)
    );
};

/**
 * Find if user have ROLE_admin
 * @param {array} roles 
 */
export const isAdmin = roles => {
    // console.log( '%cisAdministrator','color:orange', roles );
    return indexOf(roles, "ROLE_admin") >= 0;
};

export const canAddAtollonInstance = roles  =>
    {
        return isAdmin(roles);
    };

/**
 * Format timestamp into human eye friendly format
 */
export const humanFormatDate = date => format(date, "DD. MM. YYYY");
export const humanFormatHoursMinutes = date => format(date, "HH:mm");
export const formatTime = time => format(time, "DD.MM.YYYY HH:mm:ss");

export const minutesToDaysHoursMinutes = minutes => {
  if (minutes === undefined || minutes === null) return {};

  return {
    days: Math.floor(minutes / (24 * 60)),
    hours: Math.floor((minutes / 60) % 24),
    minutes: minutes % 60
  };
};

export const daysHoursMinutesToString = (
  daysHoursMinutes,
  includeCommas = false
) => {
  return `${!daysHoursMinutes.days
    ? ""
    : daysHoursMinutes.days === 1
      ? "1 den"
      : daysHoursMinutes.days < 5
        ? `${daysHoursMinutes.days} dny`
        : `${daysHoursMinutes.days} dnů`}${daysHoursMinutes.days &&
  (daysHoursMinutes.hours || daysHoursMinutes.minutes)
    ? includeCommas ? ", " : " "
    : ""}${!daysHoursMinutes.hours
    ? ""
    : daysHoursMinutes.hours === 1
      ? "1 hodina"
      : daysHoursMinutes.hours < 5
        ? `${daysHoursMinutes.hours} hodiny`
        : `${daysHoursMinutes.hours} hodin`}${daysHoursMinutes.hours &&
  daysHoursMinutes.minutes
    ? includeCommas ? ", " : " "
    : ""}${!daysHoursMinutes.minutes
    ? ""
    : daysHoursMinutes.minutes === 1
      ? "1 minuta"
      : daysHoursMinutes.minutes < 5
        ? `${daysHoursMinutes.minutes} minuty`
        : `${daysHoursMinutes.minutes} minut`}`;
};

export const minutesToDaysHoursMinutesString = (minutes, includeCommas) =>
  daysHoursMinutesToString(minutesToDaysHoursMinutes(minutes), includeCommas);



// USAGE:
// - prints errors to user
// - people can print screen error message
// - does not redirect ! It is bad ux.
// FIXME: what does await change ?
export const alertBackendError = async ( err ) => {

    const userFriendlyErrorMessage = ( serverMessage ) =>
    {
        // TODO: numerical message codes
        if( serverMessage === 'DNS already used.')
        {
            // TODO: translate
            return Translate("This Instance Name already exists","This Instance Name already exists");
        }
        else
        {
            return serverMessage;
        }
    };

    let errorMessage = '';
    let redirectUrl = window.location.href.replace(/\/touch.*$/g, "/touch/server-down");

    if( err.response )
    {
        let url = err.response.url;
        let status = err.response.status;
        let statusText = err.response.statusText;
        let method = err.method;
        let time = err.time;
        let serverResponseMessage = '';

        errorMessage += 'ERROR';

        {
            let serverResponse = {};

            // Awaiting again to get .json() or .text() is a TypeError in Javascript
            if( err.parsedResponse )
            {
                // Result was awaited
                serverResponse = err.parsedResponse.json;
            }
            else
            {
                // Result was not awaited
                // - typical case for Touch code
                try
                {
                    serverResponse = await err.response.json();
                }
                catch( _ )
                {
                }
            }

            try
            {
                let message;
                let description;
                let code;
                let toFix;
                message = serverResponse.message;
                description = serverResponse.description;
                code = serverResponse.code;
                toFix = serverResponse.toFix;
                if( code ){ errorMessage += "\nError Code: " + ( code ); }
                if( message ){ errorMessage += "\nMessage: " + userFriendlyErrorMessage( message ); }
                if( description ){ errorMessage += "\nDescription: " + ( description ); }
                if( toFix ){ errorMessage += "\nPossible fix: " + ( toFix ); }

                // err.responseJson.resul
                if( serverResponse.reason )
                {
                    serverResponseMessage += "\nReason: " + serverResponse.reason;
                }

                serverResponseMessage += "\nResponse JSON: " + JSON.stringify( serverResponse );
            }
            catch(_)
            {
                debugger;
            }
        }

        errorMessage += '\n\nDETAILS';
        if( time ) { errorMessage += '\nTime: ' + time; }
        if( method ) { errorMessage += '\nMethod: ' + method; }
        errorMessage += '\nUrl: ' + url;
        errorMessage += '\nStatus Code: ' + status + ' (' + statusText + ')';
        errorMessage += serverResponseMessage;

        // errorMessage += '\n\nACTION';
        // errorMessage += '\nRedirecting to: ' + redirectUrl;
    }
    else if( err.exception )
    {
        debugger;

        let method = err.method;
        let time = err.time;

        if(err.url)
        {
            errorMessage += '\n';
            if( time ) { errorMessage += '\nTime: ' + time; }
            if( method ) { errorMessage += '\nMethod: ' + method; }
            errorMessage += '\nUrl: ' + err.url;
            errorMessage += '\n';
        }
        errorMessage += "\nEXCEPTION";
        errorMessage += "\n" + err.exception;
    }

    // NOTE: Redux debugger will reset on change of location!

    if( 1 ){ // debug.debug_isEnabled() ) {

        // TODO: have notion of fatal errors and non-fatal ones

        if( ! err.doNotAlertErrors )
        {
            alert(errorMessage);
        }
        console.log(errorMessage);
    }
    else
    {
        window.location.replace( redirectUrl );
    }
};

export const isEmail = value =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value);

export const isDomain = value => /^[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value);


export const humanFormatPrice = ( price, priceCurrency ) =>
{
    const rounded = Number( price ).toFixed( 2 );

    const spacesBetweenDigits = ( str ) =>
    {
        let digits = 1;
        let out = '';
        for( let i = str.length - 1; i >= 0; i-- )
        {
            out = str[i] + out;

            if( i > 0 )
            {
                if( digits === 3 )
                {
                    out = ' ' + out;
                    digits = 1;
                }
                else
                {
                    digits++;
                }
            }
        }
        return out;
    }
    const parts = rounded.split(".");
    let text = ( priceCurrency ? priceCurrency + " " : '' ) + spacesBetweenDigits( parts[0] ) + "." + parts[1];
    return text;
};


// WEBPACK FOOTER //
// ./src/utils/index.js